import { useCustomerContext } from '~src/context/CustomerContext';
import { TakeoverType } from '~src/model';
import { useAnalytics } from '~src/tracking/ga';

export const useProceedProperties = (
  setShowModal: (flag: boolean) => void,
  updateStage: (stage: number) => void,
  takeover?: TakeoverType
) => {
  const { quoteOpened } = useAnalytics();
  const { customer } = useCustomerContext();

  return (index: number, maxIndex: number, stage: number) => {
    if (takeover && index === maxIndex) {
      return { onProceed: undefined, proceedText: '' };
    }

    if (index === maxIndex) {
      return {
        onProceed: () => {
          quoteOpened(customer?.email ?? undefined);
          setShowModal(true);
        },
        proceedText: 'Modtag Tilbud',
      };
    }

    if (index > 0) {
      return { onProceed: () => updateStage(stage) };
    }

    return { onProceed: undefined, proceedText: '' };
  };
};
